import { Component, OnInit } from "@angular/core";
// import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserMgmtService } from "../user.service";
import { RolesService } from "../../roles/roles.service";
import { CommonService } from "../../../shared/common.service";
import { MatSnackBar } from "@angular/material";


@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {
  userDetails;
  auditLogsList:[];
  showUserList:boolean = false;
  resetPass;
  showaAudit:boolean =false;
  query: string;
  roleList;
  passwordForm: FormGroup;
  statusFormSubmitted: boolean = false;
  hasWriteAccess: boolean = false;
  hasReadAccess:boolean = false;
  editUserForm: FormGroup;
  statusForm: FormGroup;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
    { id: "blocked", name: "Block" }
  ];
  currentUser: any = null;
  modaldata;
  stateList = [];
  roles = [];
  // END - Update user variable
  // filters
  searchStartDate: string;
  searchEndDate: string;
  searchUserStatus: string = "all";
  searchBy: string = "all";
  searchText1: string;
  searchText2: string;
  searchText3: string;
  // filters end

  userList = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 10;
  userSearchType: number = 0;
  minDate: any;
  maxDate: any;
  isLoading: boolean=false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  closeResult: string;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  mobilePattern =/^[0][1-9][0-9]*$/;

  private modalRef: NgbModalRef;

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private userService: UserMgmtService,
    private roleService: RolesService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    // const perm = this.commonService.getPermissions('users');
    // this.hasWriteAccess = perm === 'W';
    // this.hasReadAccess = perm === 'R' || perm === 'W';
    this.getUserList();
    // this.getstateList();
    // this.getRolesList();
    // this.initEditForm();
  }

  initEditForm() {
    this.editUserForm = this.formBuilder.group({
      fullName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      mobile: ['', [Validators.minLength(10)]],
      address: ['', [Validators.required]],
      stateId: ['', [Validators.required]],
      role: ['', [Validators.required]]
    });
  }

  getstateList() {
    this.isLoading = true;
    this.userService.getStateIdList().subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.stateList = res["data"]["stateList"];
          console.log(this.stateList)
        } else {
          this.stateList = [];
        }
        this.isLoading = false;
      }, err => {
        this.isLoading = false;
      }
    );
  }

  getRolesList(): void {
    this.roleService.getRolesList().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.roles = res["data"]["roleList"];
      } else {
        this.roles = [];
      }
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }

  openModal(row, content) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:'md'
    };
    this.editUserForm.patchValue({
      fullName: row["fullName"],
      email: row['email'],
      address: row["address"],
      mobile: row['mobile'],
      stateId: row['stateId'],
      role: row['role']
    });
    this.currentUser = { ...row };

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
        this.editUserForm.reset();
        this.currentUser = null;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.editUserForm.reset();
        this.currentUser = null;
      }
    );
  }

  initializeForm() {
  
    this.passwordForm = this.formBuilder.group({
      password: ["", [Validators.required,Validators.minLength(6)]]
    });
  }

  updatePasswordModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:'md'
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.resetPass = row;
    this.initializeForm();
    this.statusFormSubmitted = false;

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  resetPasword () {
    this.isLoading = true;
    let request = {
      "userId": this.resetPass['userId'],
      "newPassword": this.passwordForm.value.password
  }
    this.userMgmtService.resetPassword(request).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.passwordForm.reset();
          this.modalRef.close();
          this._snackBar.open("Password reset successfully!","",{
            duration: 5000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['success']
          });
          // Swal.fire("Success", "Password reset successfully!", "success");
        } else {
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  submitUser() {
    let verifyReq = null;
    let request = { ...this.editUserForm.value }
    if (request['mobile'] !== this.currentUser['mobile'] || request['email'] !== this.currentUser['email']) {
      verifyReq = {};
      if (request['mobile'] !== this.currentUser['mobile']) {
        verifyReq['mobile'] = request['mobile'];
      }

      if (request['email'] !== this.currentUser['email']) {
        verifyReq['email'] = request['email'];
      }
    }

    if (verifyReq) {
      this.verifyUserAndUpdate(verifyReq)
    } else {
      this.updateUser();
    }
  }

  verifyUserAndUpdate(verifyReq) {
    this.isLoading = true;
    this.userService.verifyUser(verifyReq).subscribe(res => {
      this.isLoading = false;
      if (res["message"] == "Success") {
        this.updateUser();
      } else {
        this.isLoading = false;
      }
    }, err => {
      this.isLoading = false;
    });
  }

  updateUser() {
    this.isLoading = true;
    let request = {
      userId: this.currentUser['userId'],
      ...this.editUserForm.value
    };

    this.userService.updateUserStatus(request).subscribe(res => {
      this.isLoading = false;
      if (res["message"] == "Success") {
        this._snackBar.open("User updated successfully!","",{
          duration: 5000,
          horizontalPosition:'right',
          verticalPosition:'top',
          panelClass: ['success']
        });
        // Swal.fire("Success", "User updated successfully!", "success");
        this.getUserList();
        this.modalRef.close();
        this.editUserForm.reset();
        this.currentUser = null;
      }
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }

  queryParams() {
    let query = '';
    if (this.searchUserStatus && this.searchUserStatus != "all") query = query + "status=" + this.searchUserStatus+"&";

    if (this.searchBy && this.searchBy == "email" && this.searchText1 && this.searchText1 !== '') {
      query = query + "email=" + this.searchText1.trim()+"&";
    }
    if (this.searchBy && this.searchBy == "mobile" && this.searchText2 && this.searchText2 !== '') {
      query = query + "mobile=" + this.searchText2.trim()+"&";
    }
    if (this.searchBy && this.searchBy == "role" && this.searchText3 && this.searchText3 !== '') {
      query = query + "role=" + this.searchText3.trim()+"&";
    }
    if (this.searchStartDate && this.searchStartDate != '') {
      // convert to epoch time
      let startDate = new Date(this.searchStartDate);
      query = query + "startDate=" + Math.floor(startDate.getTime() / 1000);
    }
    if (this.searchEndDate && this.searchEndDate != '') {
      // convert to epoch time
      let endDate = new Date(this.searchEndDate);
      endDate.setDate(endDate.getDate() + 1);
      query = query + "&endDate=" + Math.floor(endDate.getTime() / 1000);
    }
    return query;
  }
  // GET USERS (By Default ALL)
  getUserList() {
    this.showUserList = false;
    this.isLoading = true;
   
    let queryParam = '';
    var queryValue = this.queryParams();
    this.isLoading = true;
    this.userMgmtService.getUserListApi(queryValue).subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.userList = res["data"]["userList"];
        if(this.userList.length >0) {
          this.showUserList = true;
        }

        // console.log(this.userList)
      } else {
        this.userList = [];
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }

  onReset() {
    this.showUserList = true;
    this.isLoading = true;
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.isLoading= false;
    }, 2000);
    this.searchUserStatus = '',
    this.searchText1 = '',
    this.searchText2 = '',
    this.searchText3 = '',
    this.searchBy ='',
    (this.searchStartDate = ''),
    (this.searchEndDate = '');
    this.getUserList();
  }

  searchFiltersBtn() {
    this.getUserList();
  }

  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ['', [Validators.required]]
    });
  }

  updateUserStatusModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:'md'
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.isLoading = true;
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.userMgmtService.updateUserStatus(finalObj).subscribe(data => {
        this.isLoading = false;
        if ((data["message"] = "Success")) {
          this._snackBar.open("User status updated successfully!","",{
            duration: 5000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['success']
          });
          // Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef.close();
          this.getUserList();
        } else {
          Swal.fire("Error", data.data, "error");
        }
      },
      err => {
        this.isLoading = false;
        Swal.fire("Error", err.error.data, "error");
        this.modalRef.close();
        this.getUserList();
      });
    }
  }

  onlyAlphabets(e) {
    return (e.charCode > 64 && e.charCode < 91) || (e.charCode > 96 && e.charCode < 123) || e.charCode == 32 || e.charCode == 45;
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  auditModal(userId, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:'lg'
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    // this.auditLogsList = row;
    this.getAuditLogsList(userId);
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
        this.auditLogsList =[];
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getAuditLogsList(userId) {
    this.showaAudit = false;
    this.isLoading = true;
    this.userMgmtService.getAuditLogsListApi(userId).subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.auditLogsList = res["data"]["auditLog"];
        if(this.auditLogsList.length >0) {
          this.showaAudit = true;          
        }
        // console.log(this.userList)
      } else {
        this.auditLogsList = [];
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
